import { useRef, useCallback } from 'react';
import { useReviewStore } from '../../../stores/review';

const CardFront = ({
  setFlipped,
  text,
  isActive = true,
}: {
  text?: string;
  setFlipped: (e: any) => void;
  isActive?: boolean;
}) => {
  const { currentFlashcard } = useReviewStore();
  const { front } = currentFlashcard || {};
  const textToShow = text || front;

  const scrollRef = useRef<HTMLDivElement>(null);
  const touchStartY = useRef(0);

  const handleTouchStart = useCallback((e: React.TouchEvent) => {
    touchStartY.current = e.touches[0].clientY;
  }, []);

  const handleTouchMove = useCallback((e: React.TouchEvent) => {
    const el = scrollRef.current;
    if (!el) return;

    const deltaY = touchStartY.current - e.touches[0].clientY;
    touchStartY.current = e.touches[0].clientY;

    const isScrollable = el.scrollHeight > el.clientHeight;
    if (!isScrollable) return;

    const isAtTop = el.scrollTop <= 0 && deltaY < 0;
    const isAtBottom = el.scrollTop + el.clientHeight >= el.scrollHeight && deltaY > 0;

    if (!isAtTop && !isAtBottom) {
      e.stopPropagation();
    }

    el.scrollTop += deltaY;
  }, []);


  return (
    <div className='flex w-full flex-col items-center gap-4'>
      <div className='flex w-full max-w-[748px] flex-col gap-4'>
        <div
          className={`absolute flex h-full w-full flex-col justify-between rounded-md border-hairline border-mono-color-dark p-4 [backface-visibility:hidden] ${!isActive ? 'pointer-events-none' : ''}`}
        >
          <div className='text-right'>
            <button
              onClick={() => setFlipped(true)}
              className='text-sm font-semibold text-[#007BFF] hover:underline'
            >
              Ver verso
            </button>
          </div>
          <div className='flex flex-1 items-center justify-center overflow-hidden'>
            <div
              ref={scrollRef}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              className='[&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-transparent max-h-[140px] overflow-y-scroll [touch-action:pan-y] px-2 text-center text-lg font-semibold text-[#333333] dark:text-card-color-default [&::-webkit-scrollbar-thumb]:bg-[#d1d5dc] [&::-webkit-scrollbar]:w-1'
            >
              {textToShow}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CardFront;
